import { Message } from "element-ui";
import store from "@/store";
import axios from "axios";

const service = axios.create({
  baseURL: "/",
  timeout: 5000,
});

const errorHandle = (error) => {
  let status = 0;
  if (error.status && error.data) {
    status = error.status;
    error = error.data.message || error;
  } else {
    status = JSON.stringify(error).slice(-3);
  }
  switch (status) {
    case 401:
      Message.error("登录过期，请重新登录");
      break;
    case 403:
      Message.error("登录过期，请重新登录");
      break;
    case 404:
      Message.error("请求的资源不存在");
      break;
    default:
      // Message({
      //   message: error,
      //   type: "error",
      // });
  }
};
//http request 拦截器
service.interceptors.request.use(async (config) => {
  //如果不是登录请求，需要带验证信息
  if (store.state.login.user.token_type && config.url.indexOf("login") === -1 && config.url.indexOf("getMsgCodeForRearServiceUser") === -1) {
    config.headers.common["Authorization"] =
      "Bearer" + " " + store.state.login.user.access_token;
    config.headers.common["language"] = store.getters.locale;
  }
  config.headers.common['requestSource']= "pc"
  //登录页和首页用认证服务的网关，其他路由用自己的systemtype
  return config;
});
service.interceptors.response.use((response) => {
  if (response.status === 200 && response.data) {
    if (
      response.data.code &&
      (response.data.code === "AUTH_000004" ||
        response.data.code === "AUTH_000005" ||
        response.data.code === "AUTH_200002"||
        response.data.code === "401")||
        response.data.returnCode ==='CUS-00054'//用户未登录或登录已超时
    ) {
      //将上次登录信息清除
      store.commit("login/RESET_STATE");
      //令牌过期,令牌格式错误，未登录
      location.href="/login";
    }
    return response.data;
  }
  return response;
});

export const get = (url, params) => {
  return new Promise((resolve, reject) => {
    service
      .get(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const post = (url, params) => {
  return new Promise((resolve, reject) => {
    service
      .post(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const put = (url, params) => {
  return new Promise((resolve, reject) => {
    service
      .put(url, params)
      .then((res) => {
        if (!res.successFlag) {
          Message({
            message: res.message,
            type: "error",
          });
        }
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const remove = (url, params) => {
  return new Promise((resolve, reject) => {
    service
      .delete(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default service;
